import { inject, Injectable } from "@angular/core";
import { BaseModelService } from "app/shared/services/base-model.service";
import type { Account } from "app/shared/types/account.type";
import { environment } from "environments/environment";
import { AccountService } from "./account.service";

const BASE_URL = `${environment.BASE_URL}accounts`;

export type LoginCredentials = { email: Account["email"]; password: string };

@Injectable({
  providedIn: "root",
})
export class MfaService {
  readonly #http = inject(BaseModelService);
  readonly #accountService = inject(AccountService);

  sendMfaEmail(loginCredentials: LoginCredentials) {
    return this.#http.post<{ accountMfaCodeToken: string }>(
      `${BASE_URL}/send-mfa-email`,
      loginCredentials,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
  }

  getTOTPQRCode(accountId: string) {
    return this.#http.post<any>(
      `${BASE_URL}/${accountId}/setup-otp-mfa`,
      null,
      {
        headers: {
          Authorization: String(this.#accountService.getToken()),
        },
      },
    );
  }

  enableTOTPVerification(mfaToken: string, code: string, accountId: string) {
    return this.#http.post<any>(
      `${BASE_URL}/${accountId}/enable-otp-mfa`,
      { mfaToken, code },
      {
        headers: {
          Authorization: String(this.#accountService.getToken()),
        },
      },
    );
  }
}
